export default __webpack_public_path__ + "static/media/Poppins-ExtraLight.333cb30c.ttf";